import API from './apiConfig';

const COMMON_API = '/common';
export const getCountryEmail = async (payload) => {
  const { value, uri } = payload;
  let params = {};
  if (uri === '/email') {
    params = { contributorEmail: value };
  } else if (uri === '/country') {
    params = { country: value };
  }
  const res = await API.get(COMMON_API + uri, {
    withCredentials: true,
    params,
  });
  return res.data;
};

export const getCommonSearch = async (payload, uri) => {
  const res = await API.get(uri, {
    withCredentials: true,
    params: payload,
  });
  return res.data;
};

export const fetchCountries = async () => {
  const res = await API.get('/countries/getCountries', {
    withCredentials: true,
  });
  return res.data;
};

export const fetchTasks = async (payload) => {
  const res = await API.get('/async-tasks/all', {
    withCredentials: true,
    params: payload,
  });
  return res.data;
};
